(function($) {
    $(() => {

        $('.job-details .underline').click(function(){
            $(this).toggleClass('is-opened');
            $(this).next('.content').slideToggle();
        });
        
    });
})(jQuery);
